'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');
const components_navigation_LegacyIconButton_IconButton = require('../../navigation/LegacyIconButton/IconButton.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const root = "_root_1lhvm_1";
const styles = {
	root: root
};

const DateRangePickerNavbar = ({ onNextClick, onPreviousClick }) => {
  return React__default.default.createElement(
    "div",
    { className: styles.root, "data-zds": true },
    React__default.default.createElement(components_navigation_LegacyIconButton_IconButton.LegacyIconButton, { icon: "arrowSmallLeft", label: "Previous Month", onClick: () => onPreviousClick(), shouldCorrectTooltipPosition: false, tooltipPosition: "southwest", color: "icon-tertiary" }),
    React__default.default.createElement(components_navigation_LegacyIconButton_IconButton.LegacyIconButton, { icon: "arrowSmallRight", label: "Next Month", onClick: () => onNextClick(), shouldCorrectTooltipPosition: false, tooltipPosition: "southeast", color: "icon-tertiary" })
  );
};

exports.DateRangePickerNavbar = DateRangePickerNavbar;
//# sourceMappingURL=DateRangePickerNavbar.cjs.js.map
